import CryptoJS from 'crypto-js';

export function encryptData(data) {
  if (!data) return data;
  const key = import.meta.env.VITE_ENCRYPTION_KEY || 'FGRHrmsURLEncryptionKey';
  return CryptoJS.AES.encrypt(data, key).toString();
}

export function sameEncryptData(data) {
  if (!data) return data;
  const keyStr = import.meta.env.VITE_SAME_ENCRYPTION_KEY_VALUE || '6Le0DgMTAAAAANokdHRMSkey';
  const ivStr = import.meta.env.VITE_IV || 'mHGFxENnZLbienLyHRMSiv.e';
  const key = CryptoJS.enc.Base64.parse(keyStr);
  const iv = CryptoJS.enc.Base64.parse(ivStr);
  return CryptoJS.AES.encrypt(data, key, { iv }).toString();
}
